<template>
  <v-app light>
    <v-navigation-drawer
      fixed
      v-model="drawer"
      app
      right
      temporary
    >
      <v-list>
        <v-list-tile router to="/" exact>
          <v-list-tile-action>
            <v-icon light>home</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Home</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile router to="/settings">
          <v-list-tile-action>
            <v-icon light>settings</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Settings</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="showDisclaimer"  v-if="hasDisclaimer">
          <v-list-tile-action>
            <v-icon light>description</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>View Disclaimer</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider class="mt-3"></v-divider>
        <v-list-tile v-if="user !== null" router @click="onLogout">
          <v-list-tile-action>
            <v-icon light>exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Log Out</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar fixed app color="primary" dark>
      <v-btn v-if="user !== null" icon to="/">
        <v-icon>home</v-icon>
      </v-btn>
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-side-icon @click.stop="drawer = !drawer" right></v-toolbar-side-icon>
    </v-toolbar>
    <v-alert :value="appOutdated" color="warning" icon="history" style="position: fixed;top: 60px;width: 100%;z-index: 100;">The application has an update available <v-btn color="success" @click="resetApp" depressed>Click here to update</v-btn></v-alert>
    <v-content>
      <router-view></router-view>
    </v-content>
      <Disclaimer-Dialog :show-dialog.sync="disclaimer"></Disclaimer-Dialog>
  </v-app>
</template>

<script>
  export default {
    data () {
      return {
        drawer: false,
        fixed: false,
        title: 'T & A',
        connected: true,
        disclaimer: false
      }
    },
    created () {
    },
    computed: {
      user () {
        return this.$store.getters.user
      },
      hasDisclaimer () {
        if (this.$store.getters.disclaimerText === '' || this.$store.getters.disclaimerText === false || this.$store.getters.disclaimerText === undefined) {
          return false
        } else {
          return true
        }
      },
      appOutdated () {
        return this.$store.getters.appOutdated
      },
      applicationMode () {
        return this.$store.getters.applicationMode
      }
    },
    methods: {
      goBack () {
        this.$router.go(-1)
      },
      onLogout () {
        this.$store.dispatch('logout')
        this.$router.push('/SignIn')
      },
      showDisclaimer () {
        this.disclaimer = true
      },
      resetApp () {
        navigator.serviceWorker.getRegistrations()
          .then(function (registrations) {
            for (let registration of registrations) {
              registration.unregister()
            }
          })
          .then(function (boolean) {
            caches.delete('tanda-cache').then(function (boolean) {
              window.location.reload(true)
            })
          })
      }
    }
  }
</script>

<style>
/* Fix for Safari issue with selects and menus not displaying in full screen dialogs due to z-index being 0, not auto */
.dialog { z-index: inherit }
.application {
  font-family: "Rubik" !important;
}

.headline,
.title,
.subheading {
  font-family: "Rubik" !important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue